// Yeni personel eklerken aynı T.C./Pasaport ile kayıtlı kişiyi göster ve seçtir
import { useEffect, useState } from 'react';
import axios from 'axios';
import { UserCheck, AlertTriangle } from 'lucide-react';
import { Button } from '../../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useDuplicateTc = (companyId, idNo, nationality) => {
  const [dup, setDup] = useState(null);
  const ready = nationality === 'yabanci' ? (idNo || '').length >= 5 : /^\d{11}$/.test(idNo || '');
  useEffect(() => {
    setDup(null);
    if (!ready || !companyId) return undefined;
    let alive = true;
    const t = setTimeout(() => {
      axios.post(`${API}/employees/find-by-tc`, { company_id: companyId, tc_kimlik_no: idNo })
        .then(r => alive && setDup(r.data.exists ? r.data.employee : null)).catch(() => {});
    }, 300);
    return () => { alive = false; clearTimeout(t); };
  }, [companyId, idNo, ready]);
  return dup;
};

export const DuplicateTcNotice = ({ dup, inPermit, onSelect, isPassport }) => (
  <div className="space-y-3 rounded-lg border-2 border-amber-400 bg-amber-50 p-3 animate-in fade-in slide-in-from-top-1" data-testid="duplicate-tc-notice">
    <p className="flex items-start gap-2 text-sm font-semibold text-amber-900">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
      Bu {isPassport ? 'Pasaport No' : 'T.C. Kimlik No'} ile kayıtlı personel var. Aynı numaralı kişiyi tekrar ekleyemezsiniz.
    </p>
    <div className="flex items-center gap-3 rounded-md border border-amber-200 bg-white p-3" data-testid="duplicate-tc-person">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-100 text-sm font-bold text-amber-700">{(dup.name || '?').charAt(0).toUpperCase()}</div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-slate-800" data-testid="duplicate-tc-name">{dup.name} {dup.surname}</p>
        <p className="truncate text-xs text-slate-500">{dup.position || 'Görev belirtilmemiş'}{dup.archived ? ' · Arşivde' : ''}</p>
      </div>
    </div>
    {dup.archived ? (
      <p className="text-xs text-amber-800" data-testid="duplicate-tc-archived">Bu kişi arşivde. Personel sayfasından arşivden geri getirip talebe ekleyebilirsiniz.</p>
    ) : inPermit ? (
      <p className="text-xs font-medium text-emerald-700" data-testid="duplicate-tc-in-permit">Bu kişi zaten bu talebe ekli.</p>
    ) : (
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-amber-800">Bu kişiyi seçip talebe eklemek ister misiniz?</p>
        <Button size="sm" onClick={onSelect} className="bg-amber-600 hover:bg-amber-700" data-testid="duplicate-tc-select-btn"><UserCheck className="mr-1.5 h-4 w-4" />Bu kişiyi seç</Button>
      </div>
    )}
  </div>
);
